export default {
  black: 'hsl(0, 0%, 0%)',
  almostBlack: 'hsl(0, 0%, 7%)',
  lighterBlack: 'hsl(0, 0%, 5%)',
  darkWhite: 'hsl(0, 0%, 91%)',
  paleWhite: 'hsl(0, 0%, 95%)',
  white: 'hsl(0, 0%, 100%)',
  blue: 'hsl(240, 100%, 50%)',
  lightBlue: 'hsl(206, 75%, 42%)',
  darkBlue: 'hsl(230, 59%, 30%)',
  deepBlue: 'hsl(229, 61%, 20%)',
  paleBlue: 'hsl(191, 55%, 57%)',
  gray: 'hsl(0, 0%, 40%)',
  whiteGray: 'hsl(0, 0%, 85%)',
  almostGray: 'hsl(0, 0%, 35%)',
  lightGray: 'hsl(0, 0%, 57%)',
  paleGray: 'hsl(0, 0%, 44%)',
  red: 'hsl(2, 91%, 47%)',
  yellow: 'hsl(44, 97%, 87%)',
  brightYellow: 'hsl(45, 96%, 65%)',
};
